export enum CurrentStatusType {
  NewlyDiagnosed = 0,
  UndergoingTreatmentWithCurativeIntent = 1,
  PostTreatmentAndOnActiveSurveillance = 2,
  ActiveDiseaseOnFirstLineSystemicCancerTherapy = 3,
  ActiveDiseaseOnSecondOrFurtherLineCancerTherapy = 4,
  ActiveDiseaseNotOnActiveSystemicCancerTherapy = 5,
  Other = 6,
}

export enum PrimaryCancerTissueOfOrigin {
  Breast = 0,
  Lung = 1,
  Prostate = 2,
  Colorectal = 3,
  Ovarian = 4,
  Pancreatic = 5,
  Bladder = 6,
  Kidney = 7,
  Liver = 8,
  Esophageal = 9,
  Brain = 10,
  Endometrial = 11,
  Thyroid = 12,
  Melanoma = 13,
  SkinNonMelanoma = 14,
  Sarcoma = 15,
  UnknownOrigin = 16,
  Neuroendocrine = 17,
  Thymus = 18,
  StomachGastric = 19,
  Mesothelioma = 20,
  Cervix = 21,
  Penile = 22,
  Haematological = 23,
  HeadAndNeck = 24,
  Testicular = 25,
}

export enum HistopathologicalType {
  BreastInvasiveDuctalCarcinoma = 0,
  BreastInvasiveLobularCarcinoma = 1,
  BreastMedullaryCarcinoma = 2,
  BreastTubularCarcinoma = 3,
  BreastMucinousCarcinoma = 4,
  BreastPapillaryCarcinoma = 5,
  BreastPhyllodesTumor = 6,
  BreastDuctalCarcinomaInSitu = 7,
  BreastLobularCarcinomaInSitu = 8,
  LungNonSmallCellLungCancer = 9,
  LungNSCLCAdenocarcinoma = 10,
  LungNSCLCSquamousCellCarcinoma = 11,
  LungNSCLCLargeCellCarcinoma = 12,
  LungSmallCellLungCancer = 13,
  LungBronchioloalveolarCarcinoma = 14,
  LungCarcinoidTumor = 15,
  ProstateAdenocarcinoma = 16,
  ProstateSmallCellCarcinoma = 17,
  ProstateDuctalAdenocarcinoma = 18,
  ProstateMucinousCarcinoma = 19,
  ProstateNeuroendocrineCarcinoma = 20,
  ColorectalAdenocarcinoma = 21,
  ColorectalMucinousAdenocarcinoma = 22,
  ColorectalSignetRingCellCarcinoma = 23,
  ColorectalMedullaryCarcinoma = 24,
  OvarianSerousCarcinoma = 25,
  OvarianMucinousCarcinoma = 26,
  OvarianEndometrioidCarcinoma = 27,
  OvarianClearCellCarcinoma = 28,
  OvarianBrennerTumor = 29,
  OvarianGranulosaCellTumor = 30,
  PancreaticDuctalAdenocarcinoma = 31,
  PancreaticAcinarCellCarcinoma = 32,
  PancreaticNeuroendocrineTumors = 33,
  PancreaticSolidPseudopapillaryTumor = 34,
  BladderUrothelialCarcinoma = 35,
  BladderSquamousCellCarcinoma = 36,
  BladderAdenocarcinoma = 37,
  BladderSmallCellCarcinoma = 38,
  KidneyClearCellRCC = 39,
  KidneyPapillaryRCC = 40,
  KidneyChromophobeRCC = 41,
  KidneyCollectingDuctCarcinoma = 42,
  KidneyRenalMedullaryCarcinoma = 43,
  KidneyWilmsTumor = 44,
  LiverHepatocellularCarcinoma = 45,
  LiverFibrolamellarCarcinoma = 46,
  LiverCholangiocarcinoma = 47,
  LiverAngiosarcoma = 48,
  LiverHepatoblastoma = 49,
  EsophagealAdenocarcinoma = 50,
  EsophagealSquamousCellCarcinoma = 51,
  EsophagealSmallCellCarcinoma = 52,
  EsophagealSpindleCellCarcinoma = 53,
  BrainGlioblastomaMultiforme = 54,
  BrainAstrocytoma = 55,
  BrainOligodendroglioma = 56,
  BrainEpendymoma = 57,
  BrainMedulloblastoma = 58,
  BrainMeningioma = 59,
  BrainPituitaryAdenoma = 60,
  BrainSchwannoma = 61,
  BrainChoroidPlexusCarcinoma = 62,
  BrainPinealTumor = 63,
  EndometrialEndometrioidAdenocarcinoma = 64,
  EndometrialSerousCarcinoma = 65,
  EndometrialClearCellCarcinoma = 66,
  EndometrialCarcinosarcoma = 67,
  EndometrialMucinousAdenocarcinoma = 68,
  EndometrialSquamousCellCarcinoma = 69,
  EndometrialUndifferentiatedCarcinoma = 70,
  ThyroidPapillaryCarcinoma = 71,
  ThyroidFollicularCarcinoma = 72,
  ThyroidMedullaryCarcinoma = 73,
  ThyroidAnaplasticCarcinoma = 74,
  ThyroidHurthleCarcinoma = 75,
  MelanomaSuperficialSpreading = 76,
  MelanomaNodular = 77,
  MelanomaLentigoMaligna = 78,
  MelanomaAcralLentiginous = 79,
  MelanomaMucosal = 80,
  MelanomaDesmoplastic = 81,
  SkinBasalCellCarcinoma = 82,
  SkinBCCNodular = 83,
  SkinBCCSuperficial = 84,
  SkinBCCMorpheaform = 85,
  SkinSquamousCellCarcinoma = 86,
  SkinSCCKeratoacanthoma = 87,
  SkinSCCAdenosquamous = 88,
  SkinMerkelCellCarcinoma = 89,
  SkinDermatofibrosarcomaProtuberans = 90,
  SkinCutaneousTCellLymphoma = 91,
  SarcomaSoftTissue = 92,
  SarcomaLiposarcoma = 93,
  SarcomaLiposarcomaWellDifferentiated = 94,
  SarcomaLiposarcomaDedifferentiated = 95,
  SarcomaLiposarcomaMyxoidRoundCell = 96,
  SarcomaLiposarcomaPleomorphic = 97,
  SarcomaLeiomyosarcoma = 98,
  SarcomaRhabdomyosarcoma = 99,
  SarcomaRhabdomyosarcomaEmbryonal = 100,
  SarcomaRhabdomyosarcomaAlveolar = 101,
  SarcomaRhabdomyosarcomaPleomorphic = 102,
  SarcomaAngiosarcoma = 103,
  SarcomaFibrosarcoma = 104,
  SarcomaSynovialSarcoma = 105,
  SarcomaMalignantPeripheralNerveSheath = 106,
  SarcomaUndifferentiatedPleomorphic = 107,
  SarcomaDermatofibrosarcomaProtuberans = 108,
  SarcomaBone = 109,
  SarcomaBoneOsteosarcoma = 110,
  SarcomaBoneOsteosarcomaConventional = 111,
  SarcomaBoneOsteosarcomaTelangiectatic = 112,
  SarcomaBoneOsteosarcomaSmallCell = 113,
  SarcomaBoneOsteosarcomaHighGradeSurface = 114,
  SarcomaBoneChondrosarcoma = 115,
  SarcomaBoneChondrosarcomaConventional = 116,
  SarcomaBoneChondrosarcomaDedifferentiated = 117,
  SarcomaBoneChondrosarcomaClearCell = 118,
  SarcomaBoneEwing = 119,
  SarcomaBoneChordoma = 120,
  SarcomaBoneAdamantinoma = 121,
  MelanomaUveal = 122,
  Unknown = 123,
  UnknownAdenocarcinoma = 124,
  UnknownSquamousCellCarcinoma = 125,
  UnknownUndifferentiated = 126,
  NeuroendocrinePoorlyDifferentiated = 127,
  NeuroendocrineWellDifferentiated = 128,
  ThymusSquamousCellCarcinoma = 129,
  ThymusBasaloidCarcinoma = 130,
  ThymusMucoepidermoidCarcinoma = 131,
  ThymusLymphoepitheliomaLikeCarcinoma = 132,
  ThymusClearCellCarcinoma = 133,
  ThymusSarcomatoidCarcinoma = 134,
  ThymusAdenocarcinoma = 135,
  ThymusNUTCarcinoma = 136,
  ThymusUndifferentiatedCarcinoma = 137,
  ThymusNeuroendocrineCarcinoma = 138,
  GastricAdenocarcinoma = 140,
  GastricSquamousCellCarcinoma = 141,
  GastricUndifferentiatedCarcinoma = 142,
  MesotheliomaEpithelioid = 144,
  MesotheliomaSarcomatoid = 145,
  MesotheliomaBiphasic = 146,
  CervixSquamousCellCarcinoma = 148,
  CervixAdenocarcinoma = 149,
  SarcomaExoskeletalOsteosarcoma = 151,
  PenileSquamousCellCarcinoma = 152,
  PenileBasalCellCarcinoma = 153,
  PenileAdenocarcinoma = 154,
  PenileSarcomatoidCarcinoma = 155,
  PenileMelanoma = 156,
  HaematologicalHodgkinsLymphoma = 157,
  HaematologicalNonHodgkinsLymphomaBCell = 158,
  HaematologicalNonHodgkinsLymphomaTCell = 159,
  HaematologicalNonHodgkinsLymphomaOther = 160,
  ColorectalSquamousCellCarcinoma = 161,
  HaematologicalLeukemiaAML = 162,
  HaematologicalLeukemiaALL = 163,
  HaematologicalLeukemiaCLL = 164,
  HaematologicalLeukemiaCML = 165,
  HaematologicalLeukemiaOther = 166,
  HaematologicalMyeloma = 167,
  HaematologicalMyelodysplasticSyndrome = 168,
  HaematologicalEssentialThrombocythemia = 169,
  HaematologicalPolycythemiaVera = 170,
  HaematologicalMyelofibrosis = 171,
  HeadAndNeckSquamousCellCarcinoma = 172,
  HeadAndNeckAdenocarcinoma = 173,
  HeadAndNeckCutaneousCarcinoma = 174,
  HeadAndNeckNeuroendocrineTumor = 175,
  HeadAndNeckSarcoma = 176,
  HeadAndNeckLymphoma = 177,
  HeadAndNeckOther = 178,
  TesticularGermCellClassicSeminoma = 179,
  TesticularGermCellSpermatocyticSeminoma = 180,
  TesticularGermCellEmbryonalCarcinoma = 181,
  TesticularGermCellTeratoma = 182,
  TesticularGermCellYolkSac = 183,
  TesticularGermCellChoriocarcinoma = 184,
  TesticularGermCellMixed = 185,
  TesticularStromalTumor = 186,
  TesticularLymphoma = 187,
}

export enum CurrentStage {
  Stage1 = 0,
  Stage2 = 1,
  Stage3 = 2,
  Stage4 = 3,
}

export enum MetastasesPresent {
  AdrenalGlands = 0,
  Bone = 1,
  Brain = 2,
  Liver = 3,
  Lungs = 4,
  LymphNodes = 5,
  Pancreas = 6,
  Peritoneum = 7,
  Pleura = 8,
  Skin = 9,
}

export enum PerformanceStatus {
  FullyActive = 0,
  RestrictedInStrenuousActivity = 1,
  AmbulatorySelfCaring = 2,
  LimitedSelfCare = 3,
  CompletelyDisabled = 4,
}

export enum PatientSignupStatus {
  WaitingForPayment,
  WaitingForEnrolment,
  AwaitingVerification,
  EligibleLabTestPending,
  ElegibleLabTestSubmitted,
  AwaitingAstronReport,
  NotEligible,
  Complete,
}

export enum EnrolmentStep {
  PersonalDetails = 0,
  ClinicalInformation = 1,
  UploadDocuments = 2,
}

export enum CancerGrade {
  Grade1 = 0,
  Grade2 = 1,
  Grade3 = 2,
  Grade4 = 4,
  Unknown = 3,
}

export enum GenderAtBirth {
  Male = 0,
  Female = 1,
}

export enum Title {
  Mr = 0,
  Mrs = 1,
  Miss = 2,
  Ms = 3,
  Dr = 4,
  Prof = 5,
}

export enum EligibilityStatus {
  InReview = 0,
  Eligible = 1,
  NotEligible = 2,
  MoreInformationRequired = 3,
  OnHold = 4,
  Refunded = 5,
  Deceased = 6,
}
